import React from 'react'
import HomePage from '../pages/home/HomePage';
import ServicesPage from '../pages/serv/ServicesPage';
import BlogPage from '../pages/blog/BlogPage';
import AboutPage from '../pages/about/AboutPage';
import ContactPage from '../pages/contact/ContactPage';
import PortfolioPage from '../pages/portFolio/portFolio';
import CareersPage from '../pages/careers/CareersPage';
import ComingSoonPage from '../pages/soon/ComingSoonPage';

import { Routes, Route, Navigate } from 'react-router'

const MainRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path='/' element={ <Navigate to={'home'}/> } />
        <Route path='/home' element={<HomePage/>} />
        <Route path='/contact' element={<ContactPage/>} />
        <Route path='/about' element={<AboutPage/>} />
       {/** <Route path='/blog' element={<BlogPage/>} /> */}
        <Route path='/services' element={<ServicesPage/>} />
        <Route path='/portfolio' element={<PortfolioPage/>} />
        <Route path='/careers' element={<CareersPage/>} />
        <Route path='/comingsoon' element={<ComingSoonPage/>} />
        
      </Routes>
    </div>
)
}

export default MainRoutes
